import React from 'react'
import './index.scss'
import { SyncLoader } from 'react-spinners'

const Spinner = ({ loading }) => {
  return (
    <div className="Spinner">
      <SyncLoader color="#fff" loading={loading} size={30} />
      {loading && <div className="bg_wrap"></div>}
    </div>
  )
}

export { Spinner }
